// eslint-disable-next-line import/extensions
import blockFilter from './filterTourProductsByAdditionalFilters/blockFilter';
import bonusMilesFilter from './filterTourProductsByAdditionalFilters/bonusMilesFilter.ts';
import mirCashbackFilter from './filterTourProductsByAdditionalFilters/mirCashbackFilter.ts';
import isExclusiveFilter from './filterTourProductsByAdditionalFilters/isExclusiveFilter';
import mealsFilter from './filterTourProductsByAdditionalFilters/mealsFilter';
import operatorsFilter from './filterTourProductsByAdditionalFilters/operatorsFilter';
import productTypeFilter from './filterTourProductsByAdditionalFilters/productTypeFilter';
import prepaymentsFilter from './filterTourProductsByAdditionalFilters/prepaymentsFilter';

export default (filters, tourProducts) => {
    const availableFilters = [{
        filterName: 'productType',
        implementation: productTypeFilter,
    }, {
        filterName: 'isExclusive',
        implementation: isExclusiveFilter,
    }, {
        filterName: 'operators',
        implementation: operatorsFilter,
    }, {
        filterName: 'meals',
        implementation: mealsFilter,
    }, {
        filterName: 'block',
        implementation: blockFilter,
    }, {
        filterName: 'prepayments',
        implementation: prepaymentsFilter,
    },
    {
        filterName: 'bonusMiles',
        implementation: bonusMilesFilter,
    }, {
        filterName: 'mirCashback',
        implementation: mirCashbackFilter,
    }];

    return _.filter(tourProducts, (tourProduct) => {
        for (let i = 0; i < availableFilters.length; i++) {
            const availableFilter = availableFilters[i];
            if (!availableFilter.implementation(tourProduct, filters.get(availableFilter.filterName))) {
                return false;
            }
        }
        return true;
    });
};